export const getCookie = name => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? JSON.parse(decodeURIComponent(match[2])) : null;
};

export const deleteCookie = name => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
